export default __webpack_public_path__ + "static/media/book.dfa06ce1.png";